var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#cardProcessingModal .modal-body[data-v-cb8088fe] {\n  height: 65vh;\n  overflow-y: auto;\n}\n\n#card_page[data-v-cb8088fe] {\n  position: absolute;\n  height: 100%;\n  width: 94.4%;\n  border: none;\n}\n\n@font-face {\n  font-family: \"password\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"/iframev2/assets/fonts/password.ttf\");\n}\n\n.hide-card-form[data-v-cb8088fe] {\n  display: none !important;\n}\n\ninput.key[data-v-cb8088fe] {\n  font-family: \"password\";\n  width: 100px;\n}\n\n.not-allowed[data-v-cb8088fe] {\n  cursor: not-allowed !important;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _CardDetails = require("./CardDetails.vue");

var _CardDetails2 = _interopRequireDefault(_CardDetails);

var _CardProcessing = require("./CardProcessing.vue");

var _CardProcessing2 = _interopRequireDefault(_CardProcessing);

var _ThreeDsForm = require("./ThreeDsForm.vue");

var _ThreeDsForm2 = _interopRequireDefault(_ThreeDsForm);

var _UserIpAddress = require("../shared/UserIpAddress.vue");

var _UserIpAddress2 = _interopRequireDefault(_UserIpAddress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    cardDetails: _CardDetails2.default,
    CardProcessing: _CardProcessing2.default,
    threeDsForm: _ThreeDsForm2.default,
    UserIpAddress: _UserIpAddress2.default
  },
  name: "NbsCard",
  props: [],
  data: function data() {
    var _ref;

    return _ref = {
      uierrors: [],
      charges: null,
      currency: null,
      logo: null,
      invoice_amount: 0,
      amount_due: 0,
      total_amount: 0,
      bill_ref: null,
      service_id: null,
      card_charges: 0,
      expiry: null,
      email: null,
      gateway: null,
      ip_address: null,
      cardjswrapper: null,
      selected_card_type_is: null,
      set_expiry_month: null,
      set_expiry_year: null,
      charged_code: null,
      card_charged: false,
      verified_charged_code: false,
      status_api_url: null,
      callback_url: null,
      processing: false,
      invoice_no: null,
      nbsPayload: {},
      base_url: null,
      invoice_number: null,
      gateway_id: null,
      msisdn: null,
      id_number: null,
      loading: false,
      submitting: false,
      clear_form: false
    }, (0, _defineProperty3.default)(_ref, "gateway", null), (0, _defineProperty3.default)(_ref, "challenge_required", false), (0, _defineProperty3.default)(_ref, "acsURL", null), (0, _defineProperty3.default)(_ref, "creq", null), (0, _defineProperty3.default)(_ref, "order_reference", null), (0, _defineProperty3.default)(_ref, "payment_reference", null), (0, _defineProperty3.default)(_ref, "user_agent", null), (0, _defineProperty3.default)(_ref, "is_loading", false), _ref;
  },


  computed: {
    charged_code_available: function charged_code_available() {
      return !this.charged_code;
    },
    can_pay: function can_pay() {
      return this.selected_card_type_is && this.uierrors.length <= 0;
    },
    expiry_month: function expiry_month() {
      if (this.expiry) {
        var split_expiry = this.expiry.split("/");
        this.set_expiry_month = split_expiry[0].trim();
        return this.set_expiry_month;
      }
    },
    expiry_year: function expiry_year() {
      if (this.expiry) {
        var split_expiry = this.expiry.split("/");
        if (split_expiry.length > 1) {
          this.set_expiry_year = split_expiry[1].trim();
          return this.set_expiry_year;
        }
        return null;
      }
    }
  },

  mounted: function mounted() {
    window.addEventListener("message", this.handleStepupMessage);
    this.user_agent = navigator.userAgent;
    $("#nbsModalV2").on("shown.bs.modal", function () {});

    $("#cardProcessingModal").on("shown.bs.modal", function () {});

    $("#cardProcessingModal").on("hidden.bs.modal", function () {
      var ifr = window.top.$("#card_page");
      ifr.attr("src", "about:blank");
    });

    $("#nbsModalV2").on("hidden.bs.modal", function () {});

    this.invoice_amount = this.$attrs["amount_net"];
    this.amount_due = this.$attrs["amount_due"];
    this.currency = this.$attrs["currency"];
    this.logo = this.$attrs["logo"];
    this.bill_ref = this.$attrs["bill_ref"];
    this.service_id = this.$attrs["service_id"];

    this.invoice_number = this.$attrs["invoice_no"];
    this.status_api_url = this.$attrs["status_api_url"];
    this.one_stage_submission_url = this.$attrs["one_stage_submission_url"];
    this.email = this.$attrs["email"];
    this.base_url = this.$attrs["base_url"];
    this.callback_url = this.$attrs["callback_url"];
    this.msisdn = this.$attrs["msisdn"] ? this.$attrs["msisdn"] : this.$attrs["id_number"];

    this.set_total_amount();
    this.notification_url = this.$attrs["notification_url"];

    this.card_charges = this.$attrs["card_charges"];
    this.charges = this.$attrs["charges"];
    this.gateway = JSON.parse(this.$attrs["gateway"]);
    this.gateway_id = this.gateway.id;
  },

  methods: {
    saveIpAddress: function saveIpAddress(ip) {
      this.ip_address = ip;
    },
    handleSubmission: async function handleSubmission(cardDetails) {
      var _this = this;

      this.loading = this.submitting = true;

      this.nbsPayload = {
        gateway_id: this.gateway_id,
        card_number: cardDetails.cardNumber,
        expiry_date: cardDetails.expiryDate,
        cvv: cardDetails.cvv,
        amount: this.total_amount,
        currency: this.currency,
        invoice_no: this.invoice_number,
        email: this.email,
        msisdn: this.msisdn,
        card_holder_name: cardDetails.firstName + " " + cardDetails.lastName,
        merchant_order_reference: this.invoice_number + new Date().toISOString().replace(/[-:T.Z]/g, "").slice(0, 14)
      };

      var submission_url = this.base_url + this.one_stage_submission_url;

      var response = null;

      try {
        response = await Vue.axios.post(submission_url, this.nbsPayload);

        if (response.data.message === "success") {
          $("#nbsModalV2").modal("hide");
          setTimeout(function () {
            $("#cardProcessingModal").modal("show");
            _this.processing = true;
          }, 300);
        } else if (response.data.message === "await_3ds") {
          var payload = {
            notification_url: this.notification_url,
            order_reference: response.data.params.order_reference,
            payment_reference: response.data.params.payment_reference,
            gateway_id: this.gateway_id,
            user_agent: this.user_agent,
            ip_address: this.ip_address
          };

          var initiate_3ds_url = this.base_url + this.gateway.authentication_url;
          var three_ds_response = await Vue.axios.post(initiate_3ds_url, payload);
          if (three_ds_response.data.message === "challenge_required") {
            this.acsURL = three_ds_response.data.params.acs_url;
            this.creq = three_ds_response.data.params.creq;
            this.order_reference = three_ds_response.data.params.order_reference;
            this.payment_reference = three_ds_response.data.params.payment_reference;

            this.challenge_required = true;
            $("#nbsModalV2").modal("hide");
            this.$nextTick(function () {
              $("#threeDSModal").modal("show");
            });
          } else if (three_ds_response.data.message === "authenticated") {
            this.order_reference = three_ds_response.data.params.order_reference;
            this.payment_reference = three_ds_response.data.params.payment_reference;

            var polling_payload = {
              order_reference: this.order_reference,
              gateway_id: this.gateway_id,
              invoice_no: this.invoice_number,
              msisdn: this.msisdn
            };
            var polling_response_url = this.base_url + this.gateway.payment_status_url;

            this.pollPaymentStatus(polling_response_url, polling_payload);
            $("#nbsModalV2").modal("hide");
            setTimeout(function () {
              $("#cardProcessingModal").modal("show");
              _this.processing = true;
            }, 300);
          } else {
            console.warn("Unexpected response:", response.data);
          }
        }
      } catch (error) {
        console.error("This is error data:", error);
      } finally {
        this.submitting = false;
        this.loading = false;
      }
    },
    calculate_card_charges: function calculate_card_charges(total_bill, rate) {
      return Math.round(total_bill * rate) / 100;
    },

    set_total_amount: function set_total_amount() {
      this.total_amount = this.invoice_amount;
    },
    handleStepupMessage: async function handleStepupMessage(event) {
      if (event.data && event.data.type === "stepup-success") {
        this.is_loading = true;
        var payload = {
          cres: event.data.cres,
          order_reference: this.order_reference,
          payment_reference: this.payment_reference,
          gateway_id: this.gateway_id
        };

        var submit_response_url = this.base_url + this.gateway.challenge_submission_url;
        var submit_response = await Vue.axios.post(submit_response_url, payload);

        var polling_payload = {
          order_reference: this.order_reference,
          gateway_id: this.gateway_id,
          invoice_no: this.invoice_number,
          msisdn: this.msisdn
        };

        var polling_response_url = this.base_url + this.gateway.payment_status_url;

        this.pollPaymentStatus(polling_response_url, polling_payload);

        $("#threeDSModal").modal("hide");
        $("#cardProcessingModal").modal("show");
      }
      if (event.data && event.data.type === "stepup-failed") {
        console.log("3DS Step-up authentication failed.");
      }
    },
    pollPaymentStatus: async function pollPaymentStatus(url, payload) {
      var attempts = 0;
      var maxAttempts = 5;
      var delay = function delay(ms) {
        return new _promise2.default(function (resolve) {
          return setTimeout(resolve, ms);
        });
      };

      while (attempts < maxAttempts) {
        attempts++;

        try {
          var response = await Vue.axios.post(url, payload);

          if (response.data.message === "success") {
            console.log("Payment successful!");
            window.top.location.href = this.callback_url;
            return;
          }
        } catch (error) {
          console.error("Polling error:", error);
        }

        await delay(3000);
      }

      console.log("Payment not successful after 5 attempts.");
      $("#cardProcessingModal").modal("hide");
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CardProcessing',{attrs:{"status_api_url":_vm.status_api_url,"invoice_no":_vm.bill_ref,"callback_url":_vm.callback_url,"gateway_id":_vm.gateway_id}}),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"threeDSModal","tabindex":"-1","role":"dialog","aria-labelledby":"threeDSModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mx-auto text-center"},[(_vm.challenge_required)?_c('threeDsForm',{attrs:{"acsURL":_vm.acsURL,"creq":_vm.creq,"is_loading":_vm.is_loading}}):_vm._e()],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"nbsModalV2","tabindex":"-1","role":"dialog","aria-labelledby":"nbsModalV2Label","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay using Visa / MasterCard")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v("\n                      "+_vm._s(_vm.currency)+"\n                      "+_vm._s(_vm.amount_due)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Card Charges*")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v("\n                      "+_vm._s(_vm.currency)+"\n                      "+_vm._s(_vm.card_charges)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Total Due*")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.total_amount))])]),_vm._v(" "),_c('cardDetails',{attrs:{"submitting":_vm.submitting,"clear_form":_vm.clear_form},on:{"collectedCardDetails":_vm.handleSubmission}}),_vm._v(" "),_c('UserIpAddress',{on:{"ip-address":_vm.saveIpAddress}})],1)])])])])])])])],1)}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"threeDSModalLabel"}},[_vm._v("\n            3D Secure Authentication\n          ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])}]
__vue__options__._scopeId = "data-v-cb8088fe"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cb8088fe", __vue__options__)
  } else {
    hotAPI.reload("data-v-cb8088fe", __vue__options__)
  }
})()}